module.exports = __webpack_public_path__ + "img/start_capture.1ecebf47.svg";